import { PaginatedApiRequest, PaginatedApiResponse } from './ServiceModels';
import { Device } from './UserDevicesModels';
import { User } from './UsersModels';

/**
 * Types of notification status
 */
export type NotificationStatus = 'ERROR' | 'SUCCESS' | 'INFO' | 'WARNING';

/**
 * Types of notifications
 */
export enum DeviceJourney {
  LOST_STOLEN_SUSPEND = 'LOST_STOLEN_SUSPEND',
  LOST_STOLEN_RESTORE = 'LOST_STOLEN_RESTORE',
  UPGRADE_PULL = 'UPGRADE_PULL',
  UPGRADE_PUSH = 'UPGRADE_PUSH',
  NEW_CONNECTION_PULL = 'NEW_CONNECTION_PULL',
  NEW_CONNECTION_PUSH = 'NEW_CONNECTION_PUSH',
  TERMINATION_TERMINATION = 'TERMINATION_TERMINATION',
  TERMINATION_SUSPEND = 'TERMINATION_SUSPEND',
  TRANSFER_PULL = 'TRANSFER_PULL',
  TRANSFER_PUSH = 'TRANSFER_PUSH',
}
export enum NotificationCounter {
  NOTIFICATION_COUNTER = 'NOTIFICATION_COUNTER',
}
export enum SimMismatch {
  SIM_MISMATCH_BETWEEN_EIDS = 'SIM_MISMATCH_BETWEEN_EIDS',
}
export enum ScheduleJourney {
  NEW_CONNECTION_SCHEDULE_1 = 'NEW_CONNECTION_SCHEDULE_1',
  NEW_CONNECTION_SCHEDULE_2 = 'NEW_CONNECTION_SCHEDULE_2',
  TERMINATION_SCHEDULE_1 = 'TERMINATION_SCHEDULE_1',
  TERMINATION_SCHEDULE_2 = 'TERMINATION_SCHEDULE_2',
  SUSPEND_SCHEDULE_1 = 'SUSPEND_SCHEDULE_1',
  SUSPEND_SCHEDULE_2 = 'SUSPEND_SCHEDULE_2',
}
export type NotificationType = DeviceJourney | NotificationCounter | SimMismatch | ScheduleJourney;

/**
 * Generic type for device journey updates like provisioning, new connections etc
 */
interface NotificationData {
  device: Device;
  user: User;
  counter: number;
  startDate: string;
  endDate: string;
}

export type DeviceJourneyData = NotificationData;

export type SimMismatchData = NotificationData;

export type ScheduleJourneyData = NotificationData;

export interface NotificationCounterData {
  counter: number;
}

export type JourneyData = NotificationData | NotificationCounterData;

/**
 * Live notification response provided by the live notifications websocket
 */
export interface LiveNotificationResponse {
  id: string;
  status: NotificationStatus;
  adminId: string;
  actionId: string;
  read: boolean;
  dateCreated: string;
  type: NotificationType;
  data: JourneyData;
}

/**
 * API request for POST /notifications/read
 */
export interface MarkNotificationAsReadRequest {
  notifications: string[];
}
export interface MarkNotificationAsReadResponse {
  unreadNotifications: number;
}

/**
 * API request for POST /notifications
 */
export type FetchNotificationsRequest = Omit<PaginatedApiRequest, 'sort' | 'sortingType'>;

export interface FetchNotificationsResponse extends PaginatedApiResponse {
  notifications: LiveNotificationResponse[];
  unreadNotifications: number;
}
